import _ from 'lodash';
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import website from './modules/website.js'

const modules = {
  website,
};

const vuexPersist = new VuexPersistence({
  key : 'vuex-main',
  storage: window.localStorage,
  reducer(state) {
    return {
      website : _.pick(state.website, ['cookieWarning']),
    }
  }
});

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  state: {
  },
  actions : {
  },
  plugins : [
      vuexPersist.plugin,
  ],
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js